import { TAG_STYLE } from 'transfix-ui/components/Tag'
import { ICarrierApplicationStates, Maybe } from 'types/graphqlTypes'
import {
  STATUS_TAG_LABELS,
  NEW_STATUS_TAG_LABELS,
  STATUS_TAG_STYLES,
  TStatusTagLabels,
  TStatusTagStyles,
} from './types'

/**
 * Returns the tag label given a motor carrier status
 * @example getStatusTagLabel(IMotorCarrierStates.pending) // 'Pending Approval'
 */
export function getStatusTagLabel<K extends ICarrierApplicationStates>(
  status: Maybe<K>,
  isUseNewStateTagsEnabled: boolean
): TStatusTagLabels[K] {
  if (!status) {
    return 'Contact Support'
  }
  if (isUseNewStateTagsEnabled) return NEW_STATUS_TAG_LABELS[status]
  return STATUS_TAG_LABELS[status]
}

/**
 * Returns the tag style given a motor carrier status
 * @example getStatusTagStyle(IMotorCarrierStates.activated) // TAG_STYLES.success
 */
export function getStatusTagStyle<K extends ICarrierApplicationStates>(
  status: Maybe<K>
): TStatusTagStyles[K] {
  if (!status) {
    return TAG_STYLE.dark
  }
  return STATUS_TAG_STYLES[status]
}
